import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import queryString from 'query-string';
import { storePaymentRefrence } from "../../redux/actions";

const PaymentCallback = props => {
  const dispatch = useDispatch();
  const form = useSelector(state => state.form);
  const { search } = props.location;
  const qs = queryString.parse(search);

  useEffect(() => {
    if (qs && qs.completionReference) {
      dispatch(storePaymentRefrence({ completionReference: qs.completionReference }));
      if (form.form === 'operator') {
        props.history.push(`/operator/payment-success`);
      } else {
        props.history.push(`/tattooist-form/payment-success`);
      }
    }
  }, []);

  return null;
}
export default withRouter(props => <PaymentCallback {...props} />);

// “completionReference” : <<Reference for the payment being completed>>,
// “paymentReference” : <<Payment Reference for which payment has been collected>>,
// “amount” : <<Amount Collected>>,
// “transactionID”
